export default __webpack_public_path__ + "static/media/chat_trainee.3fba74f5.png";